import { AppointmentType, Availability } from 'modules/mariage/models';
import { GroupCheckboxesOption } from '.';

export class Appointment {
    typeId = -1;

    weddingDate: Date | undefined;

    date = new Date();

    slot = '';

    employeeId = -1;

    answers: {
        questionId: number;
        answer: string | GroupCheckboxesOption[];
    }[] = [];
}

export interface AppointmentFormOwnProps {
    model: Appointment;
    appointmentTypes: AppointmentType[];
    onAvailabilitiesSearch: (typeId: number, date: Date) => Promise<Availability[]>;
    onSuccess: (model: Appointment) => void;
}

export type AppointmentFormProps = AppointmentFormOwnProps;
